export default __webpack_public_path__ + "static/sygnis-ea7e7bc31d63df3114a2ce519b1041d6.png";